import { FC } from 'react';
import cn from 'classnames';
import { times } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import './StepsBar.scss';

interface StepsBarProps {
  stepsAmount: number;
  currentStepIndex: number;
}

const cnBem = createBemBlockBuilder(['stepsBar']);

export const StepsBar: FC<StepsBarProps> = ({
  stepsAmount,
  currentStepIndex,
}) => {
  return (
    <div className={cnBem('__wrapper')}>
      {times(stepsAmount, index => (
        <span
          key={index}
          className={cn(cnBem('__step'), {
            [cnBem('__activeStep')]: index === currentStepIndex,
          })}
        />
      ))}
    </div>
  );
};
